<template>
  <b-modal ref="modal" title="جزئیات" size="lg" ok-only ok-title="تایید" @ok="onOk">
    <div class="card">
      <div class="card-body">
        <div class="row mb-2">
          <div class="input-group col-sm-6">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>نام کالا</span>
              </div>
            </div>
            <input v-model="model.productName" type="text" class="form-control" readonly="readonly">
          </div>
          <div class="input-group col-sm-6">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>واحد کالا</span>
              </div>
            </div>
            <input v-model="unit" type="text" class="form-control" readonly="readonly">
          </div>
          <div class="input-group col-12 my-1">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>عنوان 1</span>
              </div>
            </div>
            <input v-model="model.title1" type="text" class="form-control" readonly="readonly">
          </div>
          <div class="input-group col-12 my-1">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>عنوان 2</span>
              </div>
            </div>
            <input v-model="model.title2" type="text" class="form-control" readonly="readonly">
          </div>
        </div>
        <div class="row mb-2">
          <div class="input-group col-sm-3">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>تعداد</span>
              </div>
            </div>
            <input
              ref="number"
              v-model="model.number"
              type="number"
              class="form-control"
              @change="onChangeData"
              @keyup="onNumberChange"
              :readonly="model.mode==='view'"
            >
          </div>
          <div class="input-group col-sm-4">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>فی</span>
              </div>
            </div>
            <input
              ref="price"
              v-model="model.price"
              type="number"
              class="form-control"
              @change="onChangeData"
              @keyup="onPriceChange"
              :readonly="model.mode==='view'"
            >
          </div>
          <div class="input-group col-sm-5">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>مبلغ</span>
              </div>
            </div>
            <input
              ref="totalPrice"
              v-model="model.totalPrice === undefined? model.totalPrice : model.totalPrice.toLocaleString()"
              type="text"
              class="form-control"
              @keyup="onToatalPriceChange"
              @change="onChangeData"
              :readonly="model.mode==='view'"
            >
          </div>
        </div>
        <div class="row">
          <div class="input-group col-sm-12">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>شرح</span>
              </div>
            </div>
            <input
              v-model="model.description"
              type="text"
              class="form-control"
              @change="onChangeData"
              :readonly="model.mode==='view'"
            >
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>
<script>
export default {
  data() {
    return {
      unit: null
    };
  },
  props: {
    product: {},
    model: {
      default() {
        return {
          price: 0,
          number: 0,
          description: "",
          totalPrice: 0
        };
      },
      type: Object
    }
  },
  components: {},
  methods: {
    onToatalPriceChange(e) {
      if (this.model.number > 0) {
        let price = e.target.value / this.model.number;
        this.model.price = price;
        this.$refs.price = price;
      }
    },
    onNumberChange(e) {
      if (this.model.price > 0) {
        let totalPrice = this.model.price * e.target.value;
        this.model.totalPrice = totalPrice;
        this.$refs.totalPrice.value = totalPrice;
      } else if (this.model.totalPrice > 0) {
        let price = this.model.totalPrice / e.target.value;
        this.model.price = price;
        this.$refs.price = price;
      }
    },
    onPriceChange(e) {
      if (this.model.number > 0) {
        let totalPrice = this.model.number * e.target.value;
        this.model.totalPrice = totalPrice;
        this.$refs.totalPrice.value = totalPrice;
      }
    },
    onOk(e) {
      if (this.model.mode === "view") {
        return;
      }
      if (
        this.model.partyType &&
        this.model.partyType !== "server" &&
        this.model.number * 1 > this.model.stock
      ) {
        this.$noty.error("موجودی کافی نیست");
        e.preventDefault();
        return;
      }
      if (this.model.mode === "edit") {
        this.$emit("onProductVoucherModalOk", "update");
        return;
      }
      this.$emit("onProductVoucherModalOk", "create");
    },
    openModal() {
      this.$refs.modal.show();
    },
    onChangeData() {
      this.$emit("changepvData", this.model);
    }
  },
  beforeMount() {
    this.unit = this.model.unit.unitValue || this.model.unit;
    this.model.price = this.model.stock.lastPrice;
  },
  mounted() {
    let self = this;
    setTimeout(() => {
      self.$refs.number.focus();
      if (self.model.mode === "Create") {
        self.$refs.number.value = self.model.stock;
        self.model.number = self.model.stock;
      }
    }, 500);
  },
  beforeUpdate() {},
  watch: {
    model() {}
  }
};
</script>
